import {createI18n} from 'vue-i18n';

const messages = {
    en: {
        title: 'Title',
        keywords: 'Keywords',
        description: 'Description',
        home: 'Home',
        myHashrate: 'My Hashrate',
        myTeam: 'My team',
        hashrateMining: 'Hashrate Mining',
        stakingMining: 'Staking Mining',
        hashrateService: 'Hashrate Service',
        trade: 'Trade',
        addLiquidity: 'Add Liquidity',
        announcement: 'Announcement',
        helpCenter: 'Help Center',
        aboutAIR1: 'About AIR1',
        comingSoon: 'AIR1 officially launched',
        myWallet: 'My wallet',
        token: 'Token',
        price: 'Price',
        liquidity: 'Liquidity',
        myBalance: 'My Balance',
        goToMining: 'Go to mining',
        connect: 'Connect',
        totalNetworkHashrate: 'Total network hashrate（T)',
        myRanking: 'My ranking',
        baseHashrate: 'Base Hashrate',
        directReferralHashrate: 'Direct referral Hashrate',
        tiersHashrate: 'Tiers Hashrate',
        teamHashrate: 'Team Hashrate',
        attenuationHashrate: 'Attenuation Hashrate',
        totalHashrate: 'Total Hashrate',
        hashrateRecord: 'Hashrate Record',
        buy: 'Buy',
        hashrate: 'Hashrate',
        copyInvitationLink: 'Copy invitation link',
        myInvitationLink: 'My invitation link',
        directReferralQuantity: 'Direct referral quantity',
        personalAchievements: 'Personal achievements(U)',
        teamPerformance: 'Team performance(U)',
        todaysNewPerformance: "Today's new performance(U)",
        myLevel: 'My level',
        directRecommendationList: 'Direct Recommendation List',
        address: 'Address',
        performance: 'Performance(U)',
        time: 'Time',
        rewardComputingPower: 'Reward computing power',
        cumulativeIncome: 'Cumulative income(AIR1)',
        incomeToBeCollected: 'Income to be collected',
        receiveBenefits: 'Receive benefits',
        benefitList: 'Benefit list',
        minimumInvestmentAmount: 'Minimum investment amount 100U',
        investToGetTierRewards: 'Invest 300U to get tier rewards',
        benefitTitle: 'Benefit List',
        benefitType: 'Benefit type',
        revenueQuantity: 'Revenue quantity',
        miningRewards: 'Mining rewards',
        nodeReward: 'Node reward',
        lpDividends: 'LP dividends',
        newPerformanceRewards: 'New Performance rewards',
        managementBonusDividend: 'Management bonus dividend',
        unOpened: "Unopened",
        buy_base_hashrate:"Buy base hashrate"
    },
    zh: {
        title: '标题',
        keywords: '关键词',
        description: '描述',
        home: '首页',
        myHashrate: '我的算力',
        myTeam: '我的团队',
        hashrateMining: '算力挖矿',
        stakingMining: '质押挖矿',
        hashrateService: '算力服务',
        trade: '前往交易',
        addLiquidity: '添加流动性',
        announcement: '公告',
        helpCenter: '帮助中心',
        aboutAIR1: '关于AIR1',
        comingSoon: 'AIR1 正式启航！',
        myWallet: '我的钱包',
        token: '币种',
        price: '价格',
        liquidity: '流动性池',
        myBalance: '我的余额',
        goToMining: '前往挖矿',
        connect: '连接钱包',
        totalNetworkHashrate: '全网算力（T)',
        myRanking: '我的排名',
        baseHashrate: '基础算力',
        directReferralHashrate: '直推算力',
        tiersHashrate: '层级算力',
        teamHashrate: '团队算力',
        attenuationHashrate: '衰减算力',
        totalHashrate: '总计算力',
        hashrateRecord: '算力记录',
        buy: '购买',
        hashrate: '个人算力',
        copyInvitationLink: '复制邀请链接',
        myInvitationLink: '我的邀请地址',
        directReferralQuantity: '直推数量',
        personalAchievements: '个人业绩(U)',
        teamPerformance: '团队业绩(U)',
        todaysNewPerformance: '今日新增业绩(U)',
        myLevel: '我的等级',
        directRecommendationList: '直推列表',
        address: '地址',
        performance: '业绩(U)',
        time: '时间',
        rewardComputingPower: '奖励算力',
        cumulativeIncome: '累计收益(AIR1)',
        incomeToBeCollected: '待领取收益',
        receiveBenefits: '领取收益',
        benefitList: '收益列表',
        minimumInvestmentAmount: '最小投资金额100U',
        investToGetTierRewards: '投资300U可获得层级奖励',
        benefitTitle: '收益列表',
        benefitType: '收益类型',
        revenueQuantity: '收益数量',
        miningRewards: '挖矿奖励',
        nodeReward: '节点奖励',
        lpDividends: 'LP分红',
        newPerformanceRewards: '新增算力奖励',
        managementBonusDividend: '管理奖分红',
        unOpened: "暂未开放",
        buy_base_hashrate:"购买基础算力"
    }
};

const locale = localStorage.getItem('lang') || 'en';

const i18n = createI18n({
    locale: locale, // 设置默认语言
    messages,
});

export default i18n;